export default __webpack_public_path__ + "static/media/small.d15f4bb1.jpg";